import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const GoalHome: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        // Override viewBox & strokeWidth, since this is a solid icon
        <IconSVG viewBox="0 0 20 20" strokeWidth={0} {...props}>
            <IconPath
                fill="currentColor"
                d="M4.342 7.484c0-.343.147-.67.404-.898l4.38-3.88a1.2 1.2 0 0 1 1.59 0l4.38 3.88a1.2 1.2 0 0 1 .404.898v6.706a1.2 1.2 0 0 1-1.2 1.2H5.542a1.2 1.2 0 0 1-1.2-1.2V7.484Z"
                {...pathProps}
            />
        </IconSVG>
    );
};
